import axios from 'axios'
// import Cookies from 'js-cookie'
import { HOST } from './config'
import { getToken, clear } from './token'
import { Toast } from 'vant'
const protocol = window.location.protocol
// function reload () {
//   window.location.href = `${location.href}?time=${new Date().getTime()}`
// }
// const HOST = 'https://api.dev.focuth.com'
const HOSTS = `${protocol}//${HOST}`
const _axios = axios.create({ // 创建实例
  baseURL: HOSTS, // IP
  timeout: 10000 // 请求超时时间
})
// let toastLoading = {}
_axios.interceptors.request.use(config => {
  // handlerRequestError(_axios.request)
  // toastLoading = Toast.loading({
  //   message: '加载中...',
  //   duration: 0, // 持续展示 toast
  //   forbidClick: true
  // })
  // if (Cookies.get('X-Auth')) {
  //   config.headers['X-Auth'] = Cookies.get('X-Auth')
  // }
  if (localStorage.getItem('X-Auth')) {
    const token = localStorage.getItem('X-Auth')
    config.headers['X-Auth'] = JSON.parse(token)
  }
  return config
}, err => {
  // console.log('网络错误')
  return Promise.reject(err)
})
_axios.interceptors.response.use(response => {
  const { data, status } = response
  // if (data.code !== 200) {
  //   clear()
  //   location.replace(location.href)
  // }
  // toastLoading.clear()
  // if the custom code is not 20000, it is judged as an error.
  if (status !== 200 && status !== 201 && status !== 205) {
    return Promise.reject(new Error(data.message || 'Error'))
  } else {
    return response
  }
},
error => {
  const { data } = error.response
  if (data.code === 5001 || data.code === 5002) {
    clear()
    location.replace(location.href)
  }
  // toastLoading.clear()
  // const config = error.config
  // console.log('config', error.config, error.message)
  if (error.response) {
    /* eslint-disable-next-line */
    const response = error.response
    // console.log('status', response)
    // alert('response' + JSON.stringify(response))
  } else {
    handlerRequestError(error)
  }
  return Promise.reject(error)
}
)
function handlerRequestError (error) {
  // alert('response' + JSON.stringify(error.message))
  // alert('response code' + JSON.stringify(error.code))
  const str = '您当前的网络连接出现问题请点击刷新后重试'
  if ((error.message === 'Network Error')) {
    Toast({
      type: 'html',
      className: 'className',
      duration: 0,
      message: `<div style="display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100vw;
        height: 100vh;">
        <img style="width: 200px;
        height: 200px;" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/505.png"/>
        <span style="margin-top: 43px;
        display: block;
        width:224px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        line-height:26px;
        text-align: center;">我们的服务器正在进行优化升级请过一会再来试试吧</span>
        <button style="width:132px;
        height:44px;
        background:rgba(245,245,245,1);
        border-radius:4px;
        font-size:17px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:24px;
        border: none;
        outline: none;
        margin-top: 40px;" onclick="setTimeout(() => {
          location.href='${location.href}'
        }, 0)">刷新重试</button>
      </div>
        `
    })
  } else {
    Toast({
      type: 'html',
      className: 'className',
      duration: 0,
      message: `<div  onclick="setTimeout(() => {
        location.href='${location.href}'
      }, 0)" style="width:192px;
        display:flex;
        flex-direction: column;
        align-items: center;
        font-size:16px;
        width: 100vw;
        height: 100vh;
        justify-content: center;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        line-height:26px;">
        <div style="width: 192px;text-align:center;">${str}</div>
        <buttom style="width:132px;
        height:44px;
        line-height: 44px;
        background:rgba(245,245,245,1);
        border-radius:4px;
        margin-top: 25px;
        display: block;" >刷新</buttom>
      </div>`
    })
  }
}

// 配置默认值
// _axios.defaults.headers.common['Authorization'] = AUTH_TOKEN
_axios.defaults.headers.post['Content-Type'] = 'application/json'
/**
 * [description]
 * @param  {[type]} url     [请求地址]
 * @param  {[type]} params  [请求参数, 与url拼接的]
 * @param  {[type]} headers [请求头]
 * @param  {[type]} timeout [超时时间]
 * @return {[type]}         [返回promise]
 */
const get = function ({ url = '', params = {}, headers = {}, timeout = 10000, responseType, baseURL }) {
  if (baseURL) {
    baseURL = `${protocol}//${baseURL}`
  }
  headers.authorization = `WX_JWT ${getToken()}`
  const promise = _axios.get(url, { params, headers, timeout, responseType, baseURL })
  return promise
}
/**
 * [POST请求]
 * @param  {[type]} url     [请求地址]
 * @param  {[type]} data    [请求参数]
 * @param  {[type]} params  [地址拼接参数]
 * @param  {[type]} headers [请求头]
 * @param  {[type]} timeout [超时]
 * @return {[type]}         [返回promise]
 */
const post = function ({ url = '', data = {}, params = {}, headers = {}, timeout = 10000, baseURL }) {
  if (baseURL) {
    baseURL = `${protocol}//${baseURL}`
  }
  headers.authorization = `WX_JWT ${getToken()}`
  const promise = _axios.post(url, null, {
    // transformRequest: function (data) {
    //   return QS.stringify(data, { arrayFormat: 'brackets' })
    // },
    data,
    params,
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    timeout,
    baseURL
  })
  return promise
}
/**
 * [PUT请求]
 * @param  {[type]} url     [请求地址]
 * @param  {[type]} data    [请求参数]
 * @param  {[type]} params  [地址拼接参数]
 * @param  {[type]} headers [请求头]
 * @param  {[type]} timeout [超时]
 * @return {[type]}         [返回promise]
 */
const put = function ({ url = '', data = {}, headers = {}, baseURL }) {
  if (baseURL) {
    baseURL = `${protocol}//${baseURL}`
  }
  headers.authorization = `WX_JWT ${getToken()}`
  const promise = _axios.put(url, {
    ...data
  }, {
    baseURL
  })
  return promise
}

const $put = function ({ url = '', data = {}, headers = {}, baseURL }) {
  if (baseURL) {
    baseURL = `${protocol}//${baseURL}`
  }
  headers.authorization = `JWT ${getToken()}`
  const promise = _axios.put(url, {
    ...data
  }, {
    baseURL
  })
  return promise
}

const putFile = function ({ url = '', file, timeout = 10000000, baseURL }) {
  if (baseURL) {
    baseURL = `${protocol}//${baseURL}`
  }
  axios.defaults.headers = {
    'Content-Type': 'multipart/form-data'
  }
  const formData = new FormData()
  formData.append('name', 'test')
  formData.append('file', file)
  const promise = _axios.post(url, formData, {
    baseURL,
    timeout
  })
  return promise
}
/**
 * [DELETE请求]
 * @param  {[type]} url     [请求地址]
 * @param  {[type]} data    [请求参数]
 * @param  {[type]} params  [地址拼接参数]
 * @param  {[type]} headers [请求头]
 * @param  {[type]} timeout [超时]
 * @return {[type]}         [返回promise]
 */
const _delete = function ({ url = '', data = {}, params = {}, headers = {}, timeout = 10000, baseURL }) {
  if (baseURL) {
    baseURL = `${protocol}//${baseURL}`
  }
  headers.authorization = `WX_JWT ${getToken()}`
  const promise = _axios.delete(url, { data, params, headers, timeout, baseURL })
  return promise
}

export {
  get,
  post,
  put,
  $put,
  putFile,
  _delete
}
